import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CustomDataField from "./CustomDataField";
import Grid from "@material-ui/core/Grid";
import MaterialUiButton from "../Buttons/MaterialUiButton/MaterialUiButton";
import SimpleTextField from "../Forms/FieldTypes/TextField";

const useStyles = makeStyles((theme) => ({
  pLeft: { paddingLeft: "8px" },
  pRight: { paddingRight: "8px" },
  root: { marginTop: "1rem" },
}));

export default function CustomDataFields(props) {
  const [state, setState] = useState({ newFieldTitle: "", newFieldData: "" });
  const classes = useStyles();

  function handleChange(value, count) {
    const { customDataFields, updateCustomFields } = props;
    customDataFields[count].value = value;
    updateCustomFields(customDataFields);
  }

  function removeCustomDataField(count) {
    const { customDataFields, updateCustomFields, onRemove } = props;
    const customFields = [...customDataFields];

    // This is being added incase the parent component needs another action to occur upon data field
    // deletion. This is being added due to products and customDataFields. The label builder is expecting
    // values from the propertiesMap object. We store other things in the propertiesMap that does not
    // qualify as a customDataField.
    if (onRemove !== undefined) {
      onRemove(customFields[count]);
    }

    customFields.splice(count, 1);
    updateCustomFields(customFields);
  }

  const {
    addField,
    setAddProductLevelDataElement,
    readOnly = false,
    customDataFields = [],
    updateCustomFields,
  } = props;
  const { newFieldTitle, newFieldData } = state;
  return (
    <Grid item xs={12}>
      <Grid container>
        {/* This renders any customDataFields provided from the props */}
        {customDataFields.map((element, index) => {
          return (
            <CustomDataField
              count={index}
              handleChange={handleChange}
              key={index}
              readOnly={readOnly}
              removeField={removeCustomDataField}
              title={customDataFields[index].title}
              value={customDataFields[index].value}
            />
          );
        })}
        {/* The code below appears if the user clicks the + to add a new field. 
          Promps for the title and content of a new data field. Once the check is 
          clicked the customDataFields of the parent component is updated.*/}
        {addField ? (
          <>
            {/* Product Level Data Label */}
            <Grid className={`${classes.pRight} ${classes.root}`} item xs={6}>
              <SimpleTextField
                id="newFieldTitle"
                label="Product Level Data Label"
                onChange={(event) => {
                  event.persist();
                  setState((prevState) => ({
                    ...prevState,
                    newFieldTitle: event.target.value,
                  }));
                }}
                readOnly={readOnly}
                required
                value={newFieldTitle}
              />
            </Grid>

            {/* Product Level Data */}
            <Grid className={`${classes.pLeft} ${classes.root}`} item xs={6}>
              <SimpleTextField
                id="newFieldData"
                label="Product Level Data"
                onChange={(event) => {
                  event.persist();
                  setState((prevState) => ({
                    ...prevState,
                    newFieldData: event.target.value,
                  }));
                }}
                readOnly={readOnly}
                value={newFieldData}
              />
            </Grid>

            {/* Are you sure you want to add a custom data field? */}
            <Grid className={`${classes.pRight} ${classes.root}`} item xs={6}>
              <MaterialUiButton
                color="secondary"
                label="SAVE"
                fullWidth={true}
                onClick={() => {
                  const customFields = customDataFields
                    ? [...customDataFields]
                    : [];
                  customFields.push({
                    title: newFieldTitle,
                    value: newFieldData,
                  });
                  updateCustomFields(customFields);
                  setState({
                    newFieldTitle: "",
                    newFieldData: "",
                  });
                  setAddProductLevelDataElement(false);
                }}
                variant="contained"
              />
            </Grid>
            <Grid className={`${classes.pLeft} ${classes.root}`} item xs={6}>
              {/* The cancel clears out all fields and sets addField back to
              false */}
              <MaterialUiButton
                color="delete"
                fullWidth={true}
                label="CANCEL"
                onClick={() => {
                  setState({
                    newFieldData: "",
                    newFieldTitle: "",
                  });
                  setAddProductLevelDataElement(false);
                }}
                variant="contained"
              />
            </Grid>
          </>
        ) : null}
      </Grid>
    </Grid>
  );
}
